export const Profile = () => {
  return <div>TODO: profile page, name change, update password, that kind of thing</div>;
};
